import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterTabsetModule } from '@shared/components/router-tabset/router-tabset.module';
import { TabNavModule } from '@shared/components/tab-nav/tab-nav.module';
import { ButtonModule } from '@shared/components/button/button.module';

import { GlobalHeaderComponent } from './global-header.component';
import { DepartmentMenuModule } from './department-menu/department-menu.module';
import { DepartmentMenuComponent } from './department-menu/department-menu.component';
import { UserMenuModule } from './user-menu/user-menu.module';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { DropdownClickDirective } from '@app/shared/directives/dropdown-click/dropdown-click.directive';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    RouterTabsetModule,
    TabNavModule,
    ButtonModule,
    NgbTypeaheadModule,
    DepartmentMenuModule,
    UserMenuModule,
  ],
  declarations: [GlobalHeaderComponent, DepartmentMenuComponent, UserMenuComponent, DropdownClickDirective],
  exports: [GlobalHeaderComponent, DepartmentMenuComponent, UserMenuComponent, DropdownClickDirective]
})
export class GlobalHeaderModule { }
